import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getConferences, setConferences } from 'store/settings';
import settingsApi from 'api/settings';

export const useSettingConferences = () => useSelector(getConferences);

export const useFetchSettings = () => {
  const dispatch = useDispatch();
  async function getDefaultConference() {
    try {
      const response = await settingsApi.getSettingByType('conferences');
      if (response?.value) {
        dispatch(setConferences(response.value));
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getDefaultConference();
  }, []);
};
